import React, { useState, useEffect } from 'react';
import '../css/Blogs.css';
import MyPhoto from '../assests/myPhoto.jpg';
import Footer from './Footer';
import Navigation from './Navigation';


const Blogs = () => {
    return (
        <>
        <Navigation/>
        <div className='container'>
        <main>
        <article class="blog-post">
            <h1>Why Every Business in Jharsuguda Needs a Professional Website</h1>
            
            <p class="intro">In today's fast-growing economy, Jharsuguda is emerging as a commercial hub in Odisha. From small shops to large industries, businesses are realizing the power of having an online presence. But why does your business need a professional website? Let's explore.</p>
            
            <h2>5 Reasons Why a Website is Essential for Jharsuguda Businesses</h2>
            
            <div class="benefits-box">
                <h3>1. Reach More Customers Locally & Beyond</h3>
                <ul>
                    <li>Over <strong>70% of customers</strong> search online before visiting a store.</li>
                    <li>A website helps businesses in <strong>Jharsuguda, Sambalpur, Rourkela</strong> attract more foot traffic.</li>
                </ul>
                
                <h3>2. 24/7 Business Visibility</h3>
                <ul>
                    <li>Unlike a physical store, your website works <strong>day and night</strong>.</li>
                    <li>Customers can check services, prices, and contact you anytime.</li>
                </ul>
                
                <h3>3. Build Trust & Credibility</h3>
                <ul>
                    <li>A <strong>well-designed website</strong> makes your business look professional.</li>
                    <li>Features like <strong>testimonials, portfolios, and contact details</strong> increase trust.</li>
                </ul>
                
                <h3>4. Compete with Bigger Brands</h3>
                <ul>
                    <li>Even small businesses in <strong>Jharsuguda</strong> can compete with established brands using <strong>SEO and digital marketing</strong>.</li>
                </ul>
                
                <h3>5. Cost-Effective Marketing</h3>
                <ul>
                    <li>A website is <strong>cheaper than print ads</strong> and reaches a wider audience.</li>
                    <li>Social media integration helps in <strong>local promotions</strong>.</li>
                </ul>
            </div>
            
            <h2>How Can I Help?</h2>
            <p>As a <strong>Jharsuguda-based Full Stack Web Developer</strong>, I create:</p>
            
            <div class="service-highlights">
                <div class="service-card">
                    <h3>Mobile-friendly business websites</h3>
                    <p>Responsive designs that work perfectly on all devices</p>
                </div>
                <div class="service-card">
                    <h3>E-commerce stores for local shops</h3>
                    <p>Online selling solutions tailored for Jharsuguda businesses</p>
                </div>
                <div class="service-card">
                    <h3>SEO-optimized sites</h3>
                    <p>Better Google rankings for local searches</p>
                </div>
            </div>
            
            <div class="cta">
                <p>Ready to establish your online presence?</p>
                <a href="/contact">Contact me today to get your business online!</a>
            </div>
            
            <div class="author-info">
                <img src={MyPhoto} alt="Web Developer Jharsuguda" class="author-img"/>
                <div>
                    <p><strong>About the Author</strong></p>
                    <p>Professional Full Stack Developer and Designer based in Jharsuguda, Odisha, specializing in creating digital solutions for local businesses.</p>
                </div>
            </div>
        </article>

        <article class="blog-post">
            <h1>How 3D Graphic Design Can Boost Your Product Sales in Odisha</h1>
            
            <p class="intro">Whether you sell handicrafts, furniture, machinery, or fashion items, high-quality 3D visuals can dramatically increase customer interest. In cities like Jharsuguda, Rourkela, and Sambalpur, businesses are using 3D product modeling to stand out. Here's how it can help you.</p>
            
            <h2>Benefits of 3D Graphic Design for Businesses</h2>
            
            <div class="benefits-box">
                <h3>1. Attractive Product Displays</h3>
                <ul>
                    <li><strong>3D renders</strong> make products look more appealing than plain photos.</li>
                    <li>Great for <strong>jewelry, furniture, and industrial equipment</strong> businesses in Odisha.</li>
                </ul>
                
                <h3>2. Save Money on Photoshoots</h3>
                <ul>
                    <li>No need for expensive photography—<strong>3D models</strong> can be customized easily.</li>
                </ul>
                
                <h3>3. Better Marketing & Social Media Engagement</h3>
                <ul>
                    <li><strong>3D posters & ads</strong> grab more attention on <strong>Facebook, Instagram, and WhatsApp</strong>.</li>
                    <li>Perfect for <strong>local promotions in Jharsuguda markets</strong>.</li>
                </ul>
                
                <h3>4. Virtual Showrooms & AR Experiences</h3>
                <ul>
                    <li>Customers can <strong>view products in 3D</strong> before buying (helpful for real estate, textiles, etc.).</li>
                </ul>
            </div>
            
            <h2>My 3D Design Services in Jharsuguda</h2>
            
            <div class="service-highlights">
                <div class="service-card">
                    <h3>3D Product Modeling</h3>
                    <p>For e-commerce, manufacturing, and product showcases</p>
                </div>
                <div class="service-card">
                    <h3>Architectural Visualization</h3>
                    <p>Stunning 3D renders for real estate and construction</p>
                </div>
                <div class="service-card">
                    <h3>Dynamic Posters & Ads</h3>
                    <p>Eye-catching marketing materials for local businesses</p>
                </div>
            </div>
            
            <div class="cta">
                <p>Want to boost your sales with stunning 3D visuals?</p>
                <a href="/contact">Let's discuss your project today!</a>
            </div>
            
            <div class="author-info">
                <img src={MyPhoto} alt="3D Designer Jharsuguda" class="author-img" />
                <div>
                    <p><strong>About the Author</strong></p>
                    <p>Professional 3D designer and web developer serving clients across Jharsuguda and Odisha, helping businesses showcase their products with cutting-edge visuals.</p>
                </div>
            </div>
        </article>
    </main>
    </div>
    <Footer/>
    </>
    );
};

export default Blogs;